/* eslint-disable max-len */
import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { reject, sortBy } from 'lodash'
import { replaceAndStrip } from '../../../../utils/string'
import { RequestPatchSettingCustomAlert, RequestPostSettingCustomAlert, RoleMember, RoleTeam, SettingCustomAlert } from '../../../../states/types/setting'
import Modal from '../../common/Modal'
import { ATTENDANCE_CLOCK_CONDITIONS, ATTENDANCE_CONDITION_TYPE, CONDITION_TYPE, CONDITION_VALUES, IMMEDIATE_LESS_THAN_OR_EQUAL_CONDITIONS, IMMEDIATE_MORE_THAN_OR_EQUAL_CONDITIONS, OPERATOR_TYPE, OPERATOR_VALUES, TIMING_TYPE, TIMING_VALUES } from '../../../constants/customAlert'
import Tips from '../../common/Tips'
import { compile } from '../../../../utils/search'
import { attendanceTimeToStandard, secToHour, standardToAttendanceTime } from '../../../../utils/date'
import AddTeamAndMemberModule from '../AddTeamAndMemberModule'
import AddMemberGroupingModule from '../AddMemberGroupingModule'

interface CustomAlertModalState {
  display: boolean
  type: string
  id: number | undefined
  customAlertDetail: SettingCustomAlert | undefined
}

interface Condition {
  condition_type: string
  operator_type: string
  detail: string | null
  service: { id: number, name: string } | null
  removable: boolean
}

interface Timing {
  type: string
  time: string
}

interface Errors {
  alert_title: string
  condition: string
  subject: string
  recipient: string
  category_time: string
  category_biz_point: string
  application_time: string
  application_biz_point: string
  slack: string
  timing_type: string
}

interface DisplayApplicationList {
  id: number
  name: string
  display: boolean
}

interface DisplaySlackChannelList {
  id: string
  name: string
  is_private: boolean
  checked: boolean
  display: boolean
}

interface SelectParam {
  members: {
    id: number
    name: string
  }[]
  teams: {
    id: number
    name: string
    scope: string
    include_nested_teams: boolean | null
  }[]
}

const SCOPE_LABEL: Record<string, string> = {
  both: "マネージャー・メンバー",
  manager: "マネージャー",
  member: "メンバー",
}

interface Props {
  customAlertModalState: CustomAlertModalState
  closeCallback: VoidFunction
  createCallback: (params: RequestPostSettingCustomAlert) => void
  updateCallback: (params: RequestPatchSettingCustomAlert) => void
  teamList: RoleTeam[]
  memberList: RoleMember[]
  candidateServices: { id: number, name: string }[]
  isCandidateServicesLoading: boolean
  slackChannels: { id: string, is_private: boolean, name: string}[]
}

const LEFT_AREA_WIDTH = 450

const DISPLAY_LIMIT = 100

const CustomAlertModal: FC<Props> = (props) => {
  const {
    customAlertModalState,
    closeCallback,
    createCallback,
    updateCallback,
    teamList,
    memberList,
    candidateServices,
    isCandidateServicesLoading,
    slackChannels,
  } = props

  const {
    login,
  } = useSelector<RootState, RootState>((state: RootState) => (state))

  const initCondition = {
    condition_type: "-",
    operator_type: "-",
    detail: "-",
    service: null,
    removable: false,
  }

  const initTiming = {
    type: "daily",
    time: "10:00",
  }

  const initErrors = {
    alert_title: "",
    condition: "",
    subject: "",
    recipient: "",
    category_time: "",
    category_biz_point: "",
    application_time: "",
    application_biz_point: "",
    slack: "",
    timing_type: "",
  }

  const applicationTimeListRef = useRef<HTMLDivElement>(null)
  const applicationBizListRef = useRef<HTMLDivElement>(null)

  const [alertTitle, setAlertTitle] = useState<string>("")
  const [conditions, setConditions] = useState<Condition[]>([initCondition])
  const [timing, setTiming] = useState<Timing>(initTiming)
  const [errors, setErrors] = useState<Errors>(initErrors)
  const [displayModal, setDisplayModal] = useState<boolean>(false)
  const [applicationTimeList, setApplicationTimeList] = useState<DisplayApplicationList[]>([])
  const [applicationBizList, setApplicationBizList] = useState<DisplayApplicationList[]>([])
  const [slackChannelList, setSlackChannelList] = useState<DisplaySlackChannelList[]>([])

  const [isDisplayApplicationTimeSelectBox, setIsDisplayApplicationTimeSelectBox] = useState<boolean>(false)
  const [isDisplayApplicationBizSelectBox, setIsDisplayApplicationBizSelectBox] = useState<boolean>(false)
  const [isDisplaySlackChannelListSelectBox, setIsDisplaySlackChannelListSelectBox] = useState<boolean>(false)

  const [searchApplicationTimeWord, setSearchApplicationTimeWord] = useState<string>("")
  const [searchApplicationBizWord, setSearchApplicationBizWord] = useState<string>("")
  const [searchSlackChannelListWord, setSearchSlackChannelListWord] = useState<string>("")

  const [composition, setComposition] = useState<boolean>(false)

  const [isCustomTiming, setIsCustomTiming] = useState<boolean>(false)

  const [selectSubjectTeams, setSelectSubjectTeams] = useState<{ id: number, scope: string, include_nested_teams: boolean | null }[]>([])
  const [selectSubjectMemberIds, setSelectSubjectMemberIds] = useState<number[]>([])
  const [selectRecipientMemberIds, setSelectRecipientMemberIds] = useState<number[]>([])

  const [openSubjectTeamIds, setOpenSubjectTeamIds] = useState<number[]>([])

  const [isNotifySelf, setIsNotifySelf] = useState<boolean>(false)
  const [isNotifySlack, setIsNotifySlack] = useState<boolean>(false)

  const [isAlertTargetTeam, setIsAlertTargetTeam] = useState<boolean>(true)

  const [isDisplayRecipientMail, setIsDisplayRecipientMail] = useState<boolean>(false)
  const [isDisplaySubjectMail, setIsDisplaySubjectMail] = useState<boolean>(false)

  const [displayApplicationTimeListCount, setDisplayApplicationTimeListCount] = useState<number>(1)
  const [displayApplicationBizListCount, setDisplayApplicationBizListCount] = useState<number>(1)

  const timeForSelect = useMemo(() => {
    const times: { label: string, value: string }[] = []
    let h = ""
    let m = ""
    for (let i = 5;i < 29;i += 1) {
      h = (`00${i}`).slice(-2)
      for (let f = 0;f < 2;f += 1) {
        m = (`00${f * 30}`).slice(-2)
        times.push({
          label: `${i ? `${i}時間` : ""}${f ? `${m}分` : ""}${!i && !f ? "0分" : ""}`,
          value: `${h}:${m}`,
        })
      }
    }
    return times
  }, [])

  const elapsedTimeForSelect = useMemo(() => {
    const times: { label: string, value: string }[] = []
    for (let i = 0;i < 24;i += 1) {
      const h = (`00${i}`).slice(-2)
      for (let f = 0;f < 2;f += 1) {
        const m = (`00${f * 30}`).slice(-2)
        times.push({
          label: `${i ? `${i}時間` : ""}${f ? `${m}分` : ""}${!i && !f ? "0分" : ""}`,
          value: `${(Number(h) * 3600) + (Number(m) * 60)}`,
        })
      }
    }
    return times
  }, [])

  const isAttendanceClockCondition = (conditionType: string): boolean => (
    (ATTENDANCE_CLOCK_CONDITIONS as readonly string[]).includes(conditionType)
  )

  const modalTitle = useMemo(() => {
    if (customAlertModalState.type === "create") return "カスタムアラートの新規作成"
    if (customAlertModalState.type === "update") return "カスタムアラートの編集"
    if (customAlertModalState.type === "duplicate") return "カスタムアラートの複製"
    return ""
  }, [customAlertModalState.type])

  const selectConditionType = useMemo(() => {
    const select_condition_type = conditions.map((condition) => condition.condition_type)
    return [...CONDITION_TYPE, ...ATTENDANCE_CONDITION_TYPE].filter((v) => select_condition_type.includes(v.value))
  }, [conditions])

  const DisplayConditionType = login.feature_config?.attendance_alert ? [...CONDITION_TYPE, ...ATTENDANCE_CONDITION_TYPE] : CONDITION_TYPE

  const getAllMemberList = (teamId: number | null): RoleMember[] => {
    if (!teamList.length) return []
    const tmpTeams = teamList.filter((v) => v.parent_team_id === teamId)
    if (!tmpTeams.length) return []
    const tmpMembers = [...tmpTeams.map((v) => [...v.managers, ...v.members]).flat(), ...tmpTeams.map((v) => getAllMemberList(v.id).flat()).flat()]
    return Array.from(new Map(tmpMembers.map((v) => [v.id, v])).values())
  }

  const buildMemberChip = (member: RoleMember, ejectCallback?: (memberId: number) => void) => (
    <div
      style={{
        border: "solid 1px #CCCCCC",
        borderRadius: "20px",
        backgroundColor: "#FFFFFF",
        padding: "4px 8px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        userSelect: "none",
      }}
      key={`target_member_id_${member.id}`}
    >
      <img
        alt="profile"
        src={
          member.profile_image
          ?? `/static/images/profile/${(Number(member.id) || 0) % 12}.jpeg`
        }
        className="profile_icon"
        style={{
          borderRadius: "50%",
          width: "14px",
        }}
      />
      {member.name}
      {
        ejectCallback && (
          <span
            style={{
              marginLeft: "4px",
              cursor: "pointer",
            }}
            onClick={() => ejectCallback(member.id)}
            role="none"
          >
            <FontAwesomeIcon icon={['fas', 'times']} />
          </span>
        )
      }
    </div>
  )

  const ejectSubjectTeamId = (teamId: number, scope: string) => {
    if (scope === "both") {
      setSelectSubjectTeams((cur) => cur.filter((v) => v.id !== teamId))
      return
    }
    if (scope === "manager") {
      if (selectSubjectTeams.find((v) => v.id === teamId)?.scope === "both") {
        setSelectSubjectTeams((cur) => cur.map((v) => (v.id === teamId ? { ...v, scope: "member" } : v)))
        return
      }
      setSelectSubjectTeams((cur) => cur.filter((v) => v.id !== teamId))
    }
    if (scope === "member") {
      if (selectSubjectTeams.find((v) => v.id === teamId)?.scope === "both") {
        setSelectSubjectTeams((cur) => cur.map((v) => (v.id === teamId ? { ...v, scope: "manager" } : v)))
        return
      }
      setSelectSubjectTeams((cur) => cur.filter((v) => v.id !== teamId))
    }
  }

  const ejectSubjectMember = (memberId: number) => {
    setSelectSubjectMemberIds((cur) => cur.filter((v) => v !== memberId))
  }

  const ejectRecipientMember = (memberId: number) => {
    setSelectRecipientMemberIds((cur) => cur.filter((v) => v !== memberId))
  }

  const toggleSubjectTeamId = (teamId: number) => {
    if (openSubjectTeamIds.includes(teamId)) {
      setOpenSubjectTeamIds((cur) => cur.filter((v) => v !== teamId))
    } else {
      setOpenSubjectTeamIds((cur) => [...cur, teamId])
    }
  }

  const closeModal = () => {
    setIsCustomTiming(false)
    closeCallback()
  }

  const replaceAndStripTitle = (event: React.FocusEvent<HTMLInputElement>) => {
    setAlertTitle(replaceAndStrip(event.target.value))
    if (event.target.value) {
      setErrors({
        ...errors,
        alert_title: "",
      })
    }
  }

  const formatDetailNumber = (index: number) => {
    const tmpConditions = [...conditions]
    tmpConditions[index].detail = Number(tmpConditions[index].detail?.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, '')).toString() || "0"
    setConditions(tmpConditions)
  }

  const validateAllowImmediate = (condition: Condition): boolean => {
    const whiteList: readonly string[] = condition.operator_type === OPERATOR_VALUES.MORE_THAN_OR_EQUAL
      ? IMMEDIATE_MORE_THAN_OR_EQUAL_CONDITIONS
      : IMMEDIATE_LESS_THAN_OR_EQUAL_CONDITIONS
    return whiteList.includes(condition.condition_type)
  }

  const canUseImmediateTiming = (targetConditions: Condition[]): boolean => targetConditions.every(validateAllowImmediate)

  // conditions
  const addCondition = () => {
    const tmpConditions = conditions.map((condition) => ({ ...condition, removable: true }))
    setConditions([...tmpConditions, {
      ...initCondition,
      removable: true,
    }])
  }

  const deleteCondition = (id: number) => {
    const tmpConditions = conditions.filter((_value, index) => index !== id)
    if (tmpConditions.length === 1) {
      setConditions(tmpConditions.map((condition) => ({ ...condition, removable: false })))
    } else {
      setConditions(tmpConditions)
    }
  }

  const updateConditionType = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const tmpConditions = [...conditions]
    tmpConditions[index].condition_type = event.target.value
    // detail
    if (event.target.value === '-') {
      tmpConditions[index].detail = initCondition.detail
      tmpConditions[index].operator_type = initCondition.operator_type
    } else if (
      event.target.value === "biz_point"
      || event.target.value === "biz_point_hour"
      || event.target.value === "application_biz_point"
      || event.target.value === "application_time"
    ) {
      tmpConditions[index].detail = "0"
      tmpConditions[index].operator_type = "less_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "holiday_work_time"
      || event.target.value === "holiday_active_time"
    ) {
      tmpConditions[index].detail = "0"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "daily_work_time"
    ) {
      tmpConditions[index].detail = "8"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "weekly_work_time"
    ) {
      tmpConditions[index].detail = "40"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "weekly",
      })
    } else if (
      event.target.value === "monthly_work_time"
    ) {
      tmpConditions[index].detail = "180"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "monthly",
      })
    } else if (
      event.target.value === "daily_over_time"
    ) {
      tmpConditions[index].detail = "2"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "weekly_over_time"
    ) {
      tmpConditions[index].detail = "10"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "weekly",
      })
    } else if (
      event.target.value === "monthly_over_time"
    ) {
      tmpConditions[index].detail = "35"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "monthly",
      })
    } else if (
      event.target.value === "labeling_rate"
    ) {
      tmpConditions[index].detail = "80"
      tmpConditions[index].operator_type = "less_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "start_time"
    ) {
      tmpConditions[index].detail = "07:00"
      tmpConditions[index].operator_type = "less_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else if (
      event.target.value === "end_time"
    ) {
      tmpConditions[index].detail = "22:00"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    } else {
      tmpConditions[index].detail = "00:00"
      tmpConditions[index].operator_type = "more_than_or_equal"
      setTiming({
        ...timing,
        type: "daily",
      })
    }
    setConditions(tmpConditions)
    if (event.target.value) {
      setErrors({
        ...errors,
        condition: "",
        timing_type: "",
      })
    }
    switch (event.target.value) {
      case "category_time":
        setErrors({
          ...errors,
          category_time: "",
        })
        break
      case "category_biz_point":
        setErrors({
          ...errors,
          category_biz_point: "",
        })
        break
      case "application_time":
        setErrors({
          ...errors,
          application_time: "",
        })
        break
      case "application_biz_point":
        setErrors({
          ...errors,
          application_biz_point: "",
        })
        break
      default:
        break
    }
  }

  const updateOperatorType = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const tmpConditions = [...conditions]
    tmpConditions[index].operator_type = event.target.value
    setConditions(tmpConditions)

    if (canUseImmediateTiming(tmpConditions)) {
      setErrors({
        ...errors,
        timing_type: "",
      })
    }
  }

  const updateDetailSelect = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const tmpConditions = [...conditions]
    tmpConditions[index].detail = event.target.value
    setConditions(tmpConditions)
  }

  const updateDetailtext = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const tmpValue = event.target.value || "0"
    const tmpConditions = [...conditions]
    tmpConditions[index].detail = tmpValue
    setConditions(tmpConditions)
  }

  const calcDetailtext = (num: number, index: number, limit: number | null) => {
    const tmpConditions = [...conditions]
    if (Number(tmpConditions[index].detail || 0) + num < 0) {
      tmpConditions[index].detail = "0"
    } else if (limit && Number(tmpConditions[index].detail || 0) + num >= limit) {
      tmpConditions[index].detail = limit?.toString()
    } else {
      tmpConditions[index].detail = (Number(tmpConditions[index].detail || 0) + num).toString()
    }
    setConditions(tmpConditions)
  }

  // application time
  const clickApplicationTime = (service: { id: number, name: string } | null, index: number) => {
    setIsDisplayApplicationTimeSelectBox(false)
    setApplicationTimeList(applicationTimeList?.map((value) => ({ ...value, display: true })))
    setSearchApplicationTimeWord("")
    const tmpConditions = [...conditions]
    tmpConditions[index].service = service
    setConditions(tmpConditions)
    setErrors({
      ...errors,
      application_time: "",
    })
  }

  const searchApplicationTime = (words: string) => {
    if (applicationTimeListRef.current) applicationTimeListRef.current.scrollTo({ top: 0, behavior: 'auto' })
    setDisplayApplicationTimeListCount(1)
    setSearchApplicationTimeWord(words)
    if (!words) {
      setApplicationTimeList(applicationTimeList?.map((value) => ({ ...value, display: true })))
      return
    }
    const word = replaceAndStrip(words).split(/\s+/)
    const list = applicationTimeList?.map((value) => {
      if (compile(word).test(value.name)) {
        return { ...value, display: true }
      }
      return { ...value, display: false }
    })
    setApplicationTimeList(sortBy(list, 'id'))
  }

  const resetSearchApplicationTime = () => {
    setSearchApplicationTimeWord("")
    setApplicationTimeList(applicationTimeList?.map((value) => ({ ...value, display: true })))
    setDisplayApplicationTimeListCount(1)
  }

  const openApplicationTimeSelectBox = () => {
    if (!applicationTimeList.length) return
    setIsDisplayApplicationTimeSelectBox(true)
    setDisplayApplicationTimeListCount(1)
  }

  // application biz
  const clickApplicationBiz = (service: { id: number, name: string } | null, index: number) => {
    setIsDisplayApplicationBizSelectBox(false)
    setApplicationBizList(applicationBizList?.map((value) => ({ ...value, display: true })))
    setSearchApplicationBizWord("")
    const tmpConditions = [...conditions]
    tmpConditions[index].service = service
    setConditions(tmpConditions)
    setErrors({
      ...errors,
      application_biz_point: "",
    })
  }

  const searchApplicationBiz = (words: string) => {
    if (applicationBizListRef.current) applicationBizListRef.current.scrollTo({ top: 0, behavior: 'auto' })
    setDisplayApplicationBizListCount(1)
    setSearchApplicationBizWord(words)
    if (!words) {
      setApplicationBizList(applicationBizList?.map((value) => ({ ...value, display: true })))
      return
    }
    const word = replaceAndStrip(words).split(/\s+/)
    const list = applicationBizList?.map((value) => {
      if (compile(word).test(value.name)) {
        return { ...value, display: true }
      }
      return { ...value, display: false }
    })
    setApplicationBizList(sortBy(list, 'id'))
  }

  const resetSearchApplicationBiz = () => {
    setSearchApplicationBizWord("")
    setApplicationBizList(applicationBizList?.map((value) => ({ ...value, display: true })))
    setDisplayApplicationBizListCount(1)
  }

  const openApplicationBizSelectBox = () => {
    if (!applicationBizList.length) return
    setIsDisplayApplicationBizSelectBox(true)
    setDisplayApplicationBizListCount(1)
  }

  const buildControlButton = (num: number, index: number, limit: number | null) => (
    <>
      <button
        type="button"
        onClick={() => calcDetailtext(num, index, limit)}
        style={{
          position: "absolute",
          right: "4px",
          top: "6px",
          padding: 0,
          border: "solid 1px #CCCCCC",
          width: "20px",
          height: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#666666",
        }}
      >
        <FontAwesomeIcon icon={['fas', 'angle-up']} />
      </button>
      <button
        type="button"
        onClick={() => calcDetailtext(-num, index, limit)}
        style={{
          position: "absolute",
          right: "4px",
          bottom: "6px",
          padding: 0,
          border: "solid 1px #CCCCCC",
          width: "20px",
          height: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#666666",
        }}
      >
        <FontAwesomeIcon icon={['fas', 'angle-down']} />
      </button>
    </>
  )

  const applicationTimeListScroll = () => {
    const element = applicationTimeListRef.current
    if (!element) return

    const { scrollTop, clientHeight, scrollHeight } = element
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10

    if (isBottom) {
      setDisplayApplicationTimeListCount((cur) => cur + 1)
    }
  }

  const applicationBizListScroll = () => {
    const element = applicationBizListRef.current
    if (!element) return

    const { scrollTop, clientHeight, scrollHeight } = element
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10

    if (isBottom) {
      setDisplayApplicationBizListCount((cur) => cur + 1)
    }
  }

  const conditionHTML = (
    conditions?.map((condition, index) => (
      <React.Fragment key={`c_a_condition_${condition.operator_type}_${index + 0}`}>
        {
          !!index && (
            <div
              style={{
                position: "relative",
                padding: "4px 8px",
                border: "solid 1px #CCCCCC",
                borderRadius: "10px",
                backgroundColor: "#EEEEEE",
                color: "#999999",
                width: "fit-content",
                margin: "-4px auto",
                zIndex: 1,
              }}
            >
              AND
            </div>
          )
        }
        <div
          className={
            `detail
            equal_space
            ${condition.condition_type === "application_time"
              || condition.condition_type === "application_biz_point"
              ? "row_4" : "row_3"}
            ${condition.removable && "removable"}`
          }
          key={`${condition.condition_type}`}
          style={{
            position: "relative",
            backgroundColor: "#E9EEF0",
            padding: "12px 8px",
            zIndex: 2006 + (conditions.length - index),
          }}
        >
          <div
            style={{
              position: "relative",
              width: condition.condition_type === "application_time"
                || condition.condition_type === "application_biz_point"
                ? "31%" : "59%",
            }}
          >
            <select
              value={condition.condition_type}
              onChange={(event) => updateConditionType(event, index)}
              style={{
                width: "100%",
              }}
            >
              <option key="none" value="-">-</option>
              <optgroup label="日次">
                {
                  Array.from(new Set([...DisplayConditionType, ...selectConditionType])).filter((v) => v.type === "daily").map((v) => (
                    <option
                      key={v.value}
                      value={v.value}
                      disabled={
                        selectConditionType.map((w) => w.value).includes(v.value)
                        || (conditions.length > 1 && !!selectConditionType.length && selectConditionType[0].type !== "daily")
                      }
                    >
                      {v.label}
                    </option>
                  ))
                }
              </optgroup>
              <optgroup label="週次">
                {
                  Array.from(new Set([...DisplayConditionType, ...selectConditionType])).filter((v) => v.type === "weekly").map((v) => (
                    <option
                      key={v.value}
                      value={v.value}
                      disabled={
                        selectConditionType.map((w) => w.value).includes(v.value)
                        || (conditions.length > 1 && !!selectConditionType.length && selectConditionType[0].type !== "weekly")
                      }
                    >
                      {v.label}
                    </option>
                  ))
                }
              </optgroup>
              <optgroup label="月次">
                {
                  Array.from(new Set([...DisplayConditionType, ...selectConditionType])).filter((v) => v.type === "monthly").map((v) => (
                    <option
                      key={v.value}
                      value={v.value}
                      disabled={
                        selectConditionType.map((w) => w.value).includes(v.value)
                        || (conditions.length > 1 && !!selectConditionType.length && selectConditionType[0].type !== "monthly")
                      }
                    >
                      {v.label}
                    </option>
                  ))
                }
              </optgroup>
            </select>
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            >
              <FontAwesomeIcon icon={['fas', 'caret-down']} />
            </div>
          </div>
          {
            (
              condition.condition_type === "application_time"
            )
            && (
              <div className="conditions_item select">
                <div
                  className="selected_item"
                  style={isCandidateServicesLoading ? { cursor: "not-allowed", opacity: 0.5 } : undefined}
                >
                  <div
                    className="modal_trigger"
                    role="none"
                    onClick={openApplicationTimeSelectBox}
                  />
                  <p>
                    {
                      condition.service?.name || "-"
                    }
                  </p>
                  <FontAwesomeIcon icon={['fas', 'caret-down']} className="icon" />
                </div>
                <div
                  className={`select_box custom_alert_select ${isDisplayApplicationTimeSelectBox || "none"}`}
                  style={{
                    top: "30px",
                    width: "400px",
                  }}
                >
                  <div className="search_area">
                    <FontAwesomeIcon
                      icon={['fas', 'search']}
                      className="icon"
                    />
                    <input
                      type="text"
                      placeholder="アプリ名で検索"
                      onChange={(event) => searchApplicationTime(event.target.value)}
                      value={searchApplicationTimeWord}
                    />
                    {
                      searchApplicationTimeWord && (
                        <button type="button" className="reset" onClick={resetSearchApplicationTime}>
                          <FontAwesomeIcon icon={['far', 'times-circle']} />
                        </button>
                      )
                    }
                  </div>
                  <div
                    className="select_list"
                    ref={applicationTimeListRef}
                    onScroll={applicationTimeListScroll}
                  >
                    <div
                      key={0}
                      className="select_row single"
                      onClick={() => clickApplicationTime(null, index)}
                      role="none"
                    >
                      -
                    </div>
                    {
                      applicationTimeList && applicationTimeList.slice(0, DISPLAY_LIMIT * displayApplicationTimeListCount).map((value: DisplayApplicationList) => (
                        value.display && (
                          <div
                            key={value.name}
                            className="select_row single"
                            onClick={() => clickApplicationTime({ id: value.id, name: value.name }, index)}
                            role="none"
                          >
                            {value.name}
                          </div>
                        )
                      ))
                    }
                  </div>
                </div>
              </div>
            )
          }
          {
            (
              condition.condition_type === "application_biz_point"
            )
            && (
              <div className="conditions_item select">
                <div
                  className="selected_item"
                  style={isCandidateServicesLoading ? { cursor: "not-allowed", opacity: 0.5 } : undefined}
                >
                  <div
                    className="modal_trigger"
                    role="none"
                    onClick={openApplicationBizSelectBox}
                  />
                  <p>
                    {
                      condition.service?.name || "-"
                    }
                  </p>
                  <FontAwesomeIcon icon={['fas', 'caret-down']} className="icon" />
                </div>
                <div
                  className={`select_box custom_alert_select ${isDisplayApplicationBizSelectBox || "none"}`}
                  style={{
                    top: "30px",
                    width: "400px",
                  }}
                >
                  <div className="search_area">
                    <FontAwesomeIcon
                      icon={['fas', 'search']}
                      className="icon"
                    />
                    <input
                      type="text"
                      placeholder="アプリ名で検索"
                      onChange={(event) => searchApplicationBiz(event.target.value)}
                      value={searchApplicationBizWord}
                    />
                    {
                      searchApplicationBizWord && (
                        <button type="button" className="reset" onClick={resetSearchApplicationBiz}>
                          <FontAwesomeIcon icon={['far', 'times-circle']} />
                        </button>
                      )
                    }
                  </div>
                  <div
                    className="select_list"
                    ref={applicationBizListRef}
                    onScroll={applicationBizListScroll}
                  >
                    <div
                      key={0}
                      className="select_row single"
                      onClick={() => clickApplicationBiz(null, index)}
                      role="none"
                    >
                      -
                    </div>
                    {
                      applicationBizList && applicationBizList.slice(0, DISPLAY_LIMIT * displayApplicationBizListCount).map((value: DisplayApplicationList) => (
                        value.display && (
                          <div
                            key={value.name}
                            className="select_row single"
                            onClick={() => clickApplicationBiz({ id: value.id, name: value.name }, index)}
                            role="none"
                          >
                            {value.name}
                          </div>
                        )
                      ))
                    }
                  </div>
                </div>
              </div>
            )
          }
          {
            condition.detail !== null && condition.condition_type === "-" && (
              <div
                style={{
                  position: "relative",
                  width: "20%",
                }}
              >
                <select
                  value={condition.detail}
                  onChange={(event) => updateDetailSelect(event, index)}
                  style={{
                    width: "100%",
                  }}
                >
                  <option value="-">-</option>
                </select>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'caret-down']} />
                </div>
              </div>
            )
          }
          {
            condition.detail !== null
            && (
              condition.condition_type === "biz_point"
              || condition.condition_type === "biz_point_hour"
              || condition.condition_type === "application_biz_point"
              || condition.condition_type === "daily_work_time"
              || condition.condition_type === "weekly_work_time"
              || condition.condition_type === "monthly_work_time"
              || condition.condition_type === "daily_over_time"
              || condition.condition_type === "weekly_over_time"
              || condition.condition_type === "monthly_over_time"
              || condition.condition_type === "holiday_work_time"
              || condition.condition_type === "holiday_active_time"
              || condition.condition_type === "labeling_rate"
            ) && (
              <div
                style={{
                  width: "20%",
                  position: "relative",
                  display: "flex",
                  alignItems: "baseline",
                  gap: "4px",
                }}
              >
                <div
                  style={{
                    width: "calc(100% - 30px)",
                    position: "relative",
                  }}
                >
                  <input
                    type="text"
                    placeholder="数値を入力してください"
                    onChange={(event) => updateDetailtext(event, index)}
                    onBlur={() => formatDetailNumber(index)}
                    onKeyDown={(e) => e.key === "Enter" && !composition && formatDetailNumber(index)}
                    onCompositionStart={() => setComposition(true)}
                    onCompositionEnd={() => setComposition(false)}
                    value={condition.detail}
                    style={{
                      width: "100%",
                    }}
                  />
                  {buildControlButton(CONDITION_TYPE.find((v) => v.value === condition.condition_type)?.step || 0, index, CONDITION_TYPE.find((v) => v.value === condition.condition_type)?.limit || null)}
                </div>
                <div
                  style={{
                    width: "26px",
                  }}
                >
                  {CONDITION_TYPE.find((v) => v.value === condition.condition_type)?.unit}
                </div>
              </div>
            )
          }
          {
            condition.detail !== null
            && (
              condition.condition_type === "start_time"
              || condition.condition_type === "end_time"
            ) && (
              <div
                style={{
                  position: "relative",
                  width: "20%",
                }}
              >
                <select
                  value={condition.detail}
                  onChange={(event) => updateDetailSelect(event, index)}
                  style={{
                    width: "100%",
                  }}
                >
                  {
                    timeForSelect.map((v) => (
                      <option key={v.value} value={v.value}>{v.value}</option>
                    ))
                  }
                </select>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'caret-down']} />
                </div>
              </div>
            )
          }
          {
            condition.detail !== null
            && condition.condition_type !== "start_time"
            && condition.condition_type !== "end_time"
            && condition.condition_type !== "biz_point"
            && condition.condition_type !== "biz_point_hour"
            && condition.condition_type !== "application_biz_point"
            && condition.condition_type !== "daily_work_time"
            && condition.condition_type !== "weekly_work_time"
            && condition.condition_type !== "monthly_work_time"
            && condition.condition_type !== "daily_over_time"
            && condition.condition_type !== "weekly_over_time"
            && condition.condition_type !== "monthly_over_time"
            && condition.condition_type !== "holiday_work_time"
            && condition.condition_type !== "holiday_active_time"
            && condition.condition_type !== "labeling_rate"
            && condition.condition_type !== "-"
            && (
              <div
                style={{
                  position: "relative",
                  width: "20%",
                }}
              >
                <select
                  value={condition.detail.toString()}
                  onChange={(event) => updateDetailSelect(event, index)}
                  style={{
                    width: "100%",
                  }}
                >
                  {
                    elapsedTimeForSelect.map((v) => (
                      <option key={v.value} value={v.value}>{v.label}</option>
                    ))
                  }
                </select>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'caret-down']} />
                </div>
              </div>
            )
          }
          <div
            style={{
              position: "relative",
              width: "11%",
            }}
          >
            <select
              value={condition.operator_type}
              onChange={(event) => updateOperatorType(event, index)}
              style={{
                width: "100%",
              }}
            >
              {
                condition.condition_type === "-" && (
                  <option value="-">-</option>
                )
              }
              {
                (condition.condition_type === "start_time" || condition.condition_type === "end_time") && (
                  OPERATOR_TYPE.map((v) => (
                    <option key={v.value} value={v.value}>{v.label_1}</option>
                  ))
                )
              }
              {
                condition.condition_type !== "start_time" && condition.condition_type !== "end_time" && condition.condition_type !== "-" && (
                  OPERATOR_TYPE.map((v) => (
                    <option key={v.value} value={v.value}>{v.label_2}</option>
                  ))
                )
              }
            </select>
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            >
              <FontAwesomeIcon icon={['fas', 'caret-down']} />
            </div>
          </div>
          {
            condition.removable ? (
              <button
                type="button"
                onClick={() => deleteCondition(index)}
                style={{
                  border: "1px solid #999999",
                  borderRadius: "4px",
                  padding: "4px",
                  fontSize: "10px",
                  color: "#ff0000",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                }}
              >
                <FontAwesomeIcon icon={['fas', 'trash-alt']} />
                削除
              </button>
            ) : (
              <div className="spacer" />
            )
          }
        </div>
        {
          condition.condition_type === "application_time" && errors.application_time && (
            <div className="error">
              {errors.application_time}
            </div>
          )
        }
        {
          condition.condition_type === "application_biz_point" && errors.application_biz_point && (
            <div className="error">
              {errors.application_biz_point}
            </div>
          )
        }
      </React.Fragment>
    ))
  )

  // slack channel list
  const clickSlackChannelList = (channelId: string) => {
    if (!slackChannelList) return
    setIsDisplaySlackChannelListSelectBox(false)
    const list = slackChannelList.map((value) => (
      value.id === channelId
        ? { ...value, checked: true, display: true }
        : { ...value, checked: false, display: true }
    ))
    setSlackChannelList(list)
    setSearchSlackChannelListWord("")
  }

  const searchSlackChannelList = (words: string) => {
    setSearchSlackChannelListWord(words)
    if (!words) {
      setSlackChannelList(slackChannelList.map((value) => ({ ...value, display: true })))
      return
    }
    const word = replaceAndStrip(words).split(/\s+/)
    const list = slackChannelList.map((value) => {
      if (compile(word).test(value.name)) {
        return { ...value, display: true }
      }
      return { ...value, display: false }
    })
    setSlackChannelList(sortBy(list, 'id'))
  }

  const resetSearchSlackChannelList = () => {
    setSearchSlackChannelListWord("")
    setSlackChannelList(slackChannelList.map((value) => ({ ...value, display: true })))
  }

  // timing
  const updateTimingType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpTiming = { ...timing }
    tmpTiming.type = event.target.value
    setTiming(tmpTiming)
    setErrors({
      ...errors,
      timing_type: "",
    })
  }

  const updateTimingTime = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tmpTiming = { ...timing }
    tmpTiming.time = event.target.value
    setTiming(tmpTiming)
  }

  const isSameMember = (a: number[], b: number[]): boolean => {
    if (a.length !== b.length) return false
    return a.every((val, index) => val === b[index])
  }

  const isSameTeam = (a: {id: number, scope: string}[], b: {id: number, scope: string}[]): boolean => {
    if (a.length !== b.length) return false

    const sortFn = (x: {id: number, scope: string}, y: {id: number, scope: string}) => x.id - y.id
    const sortedA = [...a].sort(sortFn)
    const sortedB = [...b].sort(sortFn)

    return sortedA.every((item, i) => item.id === sortedB[i].id && item.scope === sortedB[i].scope)
  }

  const saveCustomAlert = () => {
    const tmpErrors: Errors = initErrors
    const slack_channel = slackChannelList.find((value) => value.checked)
    let errorFlg = false
    if (alertTitle === "") {
      tmpErrors.alert_title = "アラート名を入力してください"
      errorFlg = true
    }
    if (selectConditionType.length === 0) {
      tmpErrors.condition = "条件を1つ以上選択してください"
      errorFlg = true
    }
    if ((isAlertTargetTeam && !selectSubjectTeams.length) || (!isAlertTargetTeam && !selectSubjectMemberIds.length)) {
      tmpErrors.subject = "アラート対象チームまたはユーザーを選択してください"
      errorFlg = true
    }
    if (slackChannelList.length && !selectRecipientMemberIds.length && !isNotifySlack) {
      tmpErrors.recipient = "アラート通知するユーザーまたはSlackチャンネルを選択してください"
      errorFlg = true
    }
    if (!slackChannelList.length && !selectRecipientMemberIds.length) {
      tmpErrors.recipient = "アラート通知するユーザーを選択してください"
      errorFlg = true
    }
    conditions.forEach((condition) => {
      switch (condition.condition_type) {
        case "application_time":
          if (!condition.service) {
            tmpErrors.application_time = "対象アプリケーションを選択してください"
            errorFlg = true
          }
          break
        case "application_biz_point":
          if (!condition.service) {
            tmpErrors.application_biz_point = "対象アプリケーションを選択してください"
            errorFlg = true
          }
          break
        default:
          break
      }
    })
    if (isNotifySlack && !slack_channel?.id) {
      tmpErrors.slack = "対象のチャンネルを選択してください"
      errorFlg = true
    }

    if (timing.type === TIMING_VALUES.IMMEDIATE) {
      const invalidConditionMessages = conditions.filter((c) => !validateAllowImmediate(c)).map((condition) => {
        const conditionLabel = [...CONDITION_TYPE, ...ATTENDANCE_CONDITION_TYPE].find((v) => v.value === condition.condition_type)?.label || condition.condition_type
        const operator = OPERATOR_TYPE.find((v) => v.value === condition.operator_type)
        const operatorLabel = condition.condition_type === CONDITION_VALUES.START_TIME || condition.condition_type === CONDITION_VALUES.END_TIME
          ? operator?.label_1
          : operator?.label_2
        return `${conditionLabel}/${operatorLabel || ""}`
      })
      if (invalidConditionMessages.length > 0) {
        tmpErrors.timing_type = `下記の条件が含まれているため、送信タイミング「即時」は使用できません。\n${invalidConditionMessages.map((m) => `・「${m}」`).join("\n")}`
        errorFlg = true
      }
    }

    setErrors({
      alert_title: tmpErrors.alert_title || "",
      condition: tmpErrors.condition || "",
      subject: tmpErrors.subject || "",
      recipient: tmpErrors.recipient || "",
      category_time: tmpErrors.category_time || "",
      category_biz_point: tmpErrors.category_biz_point || "",
      application_time: tmpErrors.application_time || "",
      application_biz_point: tmpErrors.application_biz_point || "",
      slack: tmpErrors.slack || "",
      timing_type: tmpErrors.timing_type || "",
    })
    if (errorFlg) return

    const customAlertConditions = reject(conditions, { detail: "-" }).map((condition) => {
      if (
        condition.condition_type === "biz_point"
        || condition.condition_type === "biz_point_hour"
        || condition.condition_type === "application_biz_point"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          biz_point: Number(condition.detail || 0),
          company_service_group_id: condition.service?.id,
        }
      }
      if (
        condition.condition_type === "daily_work_time"
        || condition.condition_type === "weekly_work_time"
        || condition.condition_type === "monthly_work_time"
        || condition.condition_type === "daily_over_time"
        || condition.condition_type === "weekly_over_time"
        || condition.condition_type === "monthly_over_time"
        || condition.condition_type === "holiday_work_time"
        || condition.condition_type === "holiday_active_time"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          seconds: Number(condition.detail || 0) * 3600,
        }
      }
      if (
        condition.condition_type === "active_time"
        || condition.condition_type === "not_active_time"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          seconds: Number(condition.detail || 0),
        }
      }
      if (
        condition.condition_type === "labeling_rate"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          rate: Number(condition.detail || 0),
        }
      }
      if (
        condition.condition_type === "start_time"
        || condition.condition_type === "end_time"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          time: condition.detail || "10:00",
        }
      }
      if (
        condition.condition_type === "application_time"
      ) {
        return {
          condition_type: condition.condition_type,
          operator_type: condition.operator_type,
          seconds: Number(condition.detail || 0),
          company_service_group_id: condition.service?.id,
        }
      }
      return {
        condition_type: condition.condition_type,
        operator_type: condition.operator_type,
        seconds: Number(condition.detail || 0) * 3600,
        company_service_group_id: condition.service?.id,
      }
    })

    const sendTimingTime = attendanceTimeToStandard(timing.time)

    let slack_channel_id = null
    if (slack_channel) {
      slack_channel_id = slack_channel.id
    } else if (!slack_channel && customAlertModalState.customAlertDetail) {
      slack_channel_id = customAlertModalState.customAlertDetail.recipient.slack_channel?.id
    }
    if (customAlertModalState.type === "update") {
      if (!customAlertModalState.customAlertDetail) return
      const tmpParams: RequestPatchSettingCustomAlert = {
        id: customAlertModalState.id?.toString() || "0",
        conditions: customAlertConditions,
      }
      const { customAlertDetail } = customAlertModalState
      if (customAlertDetail.name !== alertTitle) {
        tmpParams.name = alertTitle
      }
      if (customAlertDetail.send_timing !== timing.type) {
        tmpParams.send_timing = timing.type
      }
      if (customAlertDetail.send_time !== sendTimingTime) {
        tmpParams.send_time = sendTimingTime
      }
      if (isAlertTargetTeam && !isSameTeam(customAlertDetail.subject.teams, selectSubjectTeams)) {
        tmpParams.subject = tmpParams.subject ?? { notify_self: isNotifySelf }
        tmpParams.subject.teams = selectSubjectTeams
        tmpParams.subject.member_ids = []
      }
      if (!isAlertTargetTeam && !isSameMember(customAlertDetail.subject.members.map((v) => v.id), selectSubjectMemberIds)) {
        tmpParams.subject = tmpParams.subject ?? { notify_self: isNotifySelf }
        tmpParams.subject.teams = []
        tmpParams.subject.member_ids = selectSubjectMemberIds
      }
      if (customAlertDetail.subject.notify_self !== isNotifySelf) {
        tmpParams.subject = tmpParams.subject ?? { notify_self: isNotifySelf }
        tmpParams.subject.notify_self = isNotifySelf
      }
      if (!isSameMember(customAlertDetail.recipient.members.map((v) => v.id), selectRecipientMemberIds)) {
        tmpParams.recipient = tmpParams.recipient ?? {}
        tmpParams.recipient.member_ids = selectRecipientMemberIds
      }
      if (!isNotifySlack || customAlertDetail.recipient.slack_channel?.id !== slack_channel_id) {
        tmpParams.recipient = tmpParams.recipient ?? {}
        tmpParams.recipient.slack_channel_id = isNotifySlack ? slack_channel_id : null
      }
      updateCallback(tmpParams)
    } else {
      const tmpParams: RequestPostSettingCustomAlert = {
        name: alertTitle,
        send_timing: timing.type,
        send_time: sendTimingTime,
        conditions: customAlertConditions,
        subject: {
          member_ids: !isAlertTargetTeam ? selectSubjectMemberIds : [],
          teams: isAlertTargetTeam ? selectSubjectTeams : [],
          notify_self: isNotifySelf,
        },
        recipient: {
          member_ids: selectRecipientMemberIds,
          teams: [],
          slack_channel_id: slack_channel_id || null,
        },
      }
      createCallback(tmpParams)
    }
    closeModal()
  }

  const openSlackChannelListSelectBox = () => {
    if (!slackChannelList.length) return
    setIsDisplaySlackChannelListSelectBox(true)
    setErrors({
      ...errors,
      slack: "",
    })
  }

  const closeSelectBox = () => {
    setIsDisplayApplicationTimeSelectBox(false)
    setIsDisplayApplicationBizSelectBox(false)
    setIsDisplaySlackChannelListSelectBox(false)
  }

  const changeSubject = (param: SelectParam) => {
    setSelectSubjectTeams(param.teams)
    setSelectSubjectMemberIds(param.members.map((v) => v.id))
    if (param.teams.length || param.members.length) {
      setErrors({
        ...errors,
        subject: "",
      })
    }
  }

  const changeRecipient = (param: SelectParam) => {
    // setSelectRecipientTeams(param.teams)
    setSelectRecipientMemberIds(param.members.map((v) => v.id))
    if (param.teams.length || param.members.length) {
      setErrors({
        ...errors,
        recipient: "",
      })
    }
  }

  useEffect(() => {
    if (!customAlertModalState) return
    const { customAlertDetail } = customAlertModalState

    if (customAlertModalState.type !== "create" && customAlertDetail?.name) {
      setConditions(
        customAlertDetail.conditions.map((condition) => {
          let detail = "0"
          if (
            condition.condition_type === "biz_point"
            || condition.condition_type === "biz_point_hour"
            || condition.condition_type === "application_biz_point"
          ) {
            detail = condition.biz_point?.toString() || "0"
          } else if (
            condition.condition_type === "daily_work_time"
            || condition.condition_type === "weekly_work_time"
            || condition.condition_type === "monthly_work_time"
            || condition.condition_type === "daily_over_time"
            || condition.condition_type === "weekly_over_time"
            || condition.condition_type === "monthly_over_time"
            || condition.condition_type === "holiday_work_time"
            || condition.condition_type === "holiday_active_time"
          ) {
            detail = secToHour(condition.seconds || 0).toString()
          } else if (
            condition.condition_type === "active_time"
            || condition.condition_type === "not_active_time"
            || condition.condition_type === "application_time"
          ) {
            detail = (condition.seconds || 0).toString()
          } else if (
            condition.condition_type === "labeling_rate"
          ) {
            detail = condition.rate?.toString() || "0"
          } else if (isAttendanceClockCondition(condition.condition_type)) {
            const timeList = condition.time?.split(":") || ["0", "0"]
            detail = standardToAttendanceTime(Number(timeList[0]) ?? 0, Number(timeList[1]) ?? 0)
          } else {
            const timeList = condition.time?.split(":") || ["0", "0"]
            detail = `${(`00${Number(timeList[0]) ?? 0}`).slice(-2)}:${(`00${Number(timeList[1]) ?? 0}`).slice(-2)}`
          }
          return {
            condition_type: condition.condition_type,
            operator_type: condition.operator_type,
            detail: detail,
            service: condition.service ?? null,
            removable: customAlertDetail.conditions.length !== 1,
          }
        }),
      )
      if (customAlertModalState.type === "update") {
        setAlertTitle(customAlertDetail.name)
        setIsNotifySelf(customAlertDetail.subject.notify_self)
        if (slackChannels.length) {
          const channelList = slackChannels.map((value) => ({ ...value, checked: false, display: true }))
          if (customAlertDetail.recipient.slack_channel?.id) {
            channelList.unshift({
              ...customAlertDetail.recipient.slack_channel,
              checked: true,
              display: true,
            })
          } else {
            channelList.unshift({ id: "", name: "-", is_private: false, checked: true, display: true })
          }
          setSlackChannelList(channelList)
        } else {
          setSlackChannelList([])
        }
        setIsNotifySlack(!!customAlertDetail.recipient.slack_channel)
      } else {
        setAlertTitle(`${customAlertDetail.name}のコピー`)
        setIsNotifySelf(customAlertDetail.subject.notify_self)
        if (slackChannels) {
          setSlackChannelList(
            slackChannels.map((value) => ({ ...value, checked: false, display: true })),
          )
        }
      }
      const tmpTime = customAlertDetail.send_time?.split(":").map(Number) || [10, 0]
      setTiming({
        type: customAlertDetail.send_timing,
        time: standardToAttendanceTime(tmpTime[0], tmpTime[1]),
      })
      setSelectSubjectTeams(customAlertDetail.subject.teams)
      setSelectSubjectMemberIds(customAlertDetail.subject.members.map((v) => v.id))
      setSelectRecipientMemberIds(customAlertDetail.recipient.members.map((v) => v.id))
      setIsAlertTargetTeam(!!customAlertDetail.subject.teams.length)
    } else {
      setAlertTitle("")
      setConditions([initCondition])
      setTiming(initTiming)
      setIsNotifySelf(false)
      if (slackChannels.length) {
        const channelList = slackChannels.map((value) => ({ ...value, checked: false, display: true }))
        channelList.unshift({ id: "", name: "-", is_private: false, checked: false, display: true })
        setSlackChannelList(channelList)
      }
      setSelectSubjectTeams([])
      setSelectSubjectMemberIds([])
      setSelectRecipientMemberIds([])
      setIsAlertTargetTeam(true)
      setIsNotifySlack(false)
    }
    setErrors(initErrors)
  }, [customAlertModalState])

  useEffect(() => {
    setDisplayModal(customAlertModalState.display)
    if (!customAlertModalState.display) {
      closeSelectBox()
    }
  }, [customAlertModalState.display])

  useEffect(() => {
    if (!candidateServices) return
    setApplicationTimeList(
      candidateServices.map((value) => ({ id: value.id, name: value.name, display: true })),
    )
    setApplicationBizList(
      candidateServices.map((value) => ({ id: value.id, name: value.name, display: true })),
    )
  }, [candidateServices])

  return (
    <>
      <Modal
        title={modalTitle}
        show={displayModal}
        wrapperClass="custom_alert w1100 no_animation"
        closeCallback={closeModal}
        closeable
      >
        <>
          <div
            style={{
              display: "flex",
              gap: "24px",
            }}
          >
            <div
              style={{
                width: `${LEFT_AREA_WIDTH}px`,
              }}
            >
              <div className="item">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'tag']} fixedWidth />
                  アラート名
                </div>
                <div className="detail row_1">
                  <input
                    type="text"
                    placeholder="アラート名を入力してください"
                    onChange={(event) => setAlertTitle(event.target.value)}
                    onBlur={(event) => replaceAndStripTitle(event)}
                    value={alertTitle}
                  />
                </div>
                {
                  errors.alert_title && (
                    <div className="error">
                      {errors.alert_title}
                    </div>
                  )
                }
              </div>
              <div className="item">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    color: "#a50404",
                  }}
                >
                  <FontAwesomeIcon icon={['far', 'eye']} fixedWidth />
                  アラート対象範囲
                </div>
                <div className="detail row_1">
                  <div
                    style={{
                      border: "solid 1px #CCCCCC",
                      borderRadius: "4px",
                      padding: "8px",
                      display: "flex",
                      flexFlow: "column",
                      gap: "8px",
                      flexWrap: "wrap",
                      backgroundColor: "#ffeded",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "16px",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                        backgroundColor: "#FFFFFF",
                        padding: "4px",
                        fontSize: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          cursor: "pointer",
                          color: isAlertTargetTeam ? "#008800" : "#666666",
                        }}
                        onClick={() => setIsAlertTargetTeam(true)}
                        role="none"
                      >
                        <FontAwesomeIcon icon={['far', isAlertTargetTeam ? 'check-circle' : 'circle']} />
                        アラート対象チームを設定する
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          cursor: "pointer",
                          color: !isAlertTargetTeam ? "#008800" : "#666666",
                        }}
                        onClick={() => setIsAlertTargetTeam(false)}
                        role="none"
                      >
                        <FontAwesomeIcon icon={['far', !isAlertTargetTeam ? 'check-circle' : 'circle']} />
                        アラート対象ユーザーを設定する
                      </div>
                    </div>
                    <div
                      style={{
                        position: "relative",
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                        padding: "8px",
                        display: "flex",
                        flexFlow: "column",
                        gap: "4px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "4px",
                          transform: "translateY(-50%)",
                          padding: "0 4px",
                          fontSize: "10px",
                          backgroundColor: "#ffeded",
                        }}
                      >
                        {`アラート対象${isAlertTargetTeam ? "チーム" : "ユーザー"}`}
                      </div>
                      {
                        isAlertTargetTeam && !!selectSubjectTeams.length && (
                          <div
                            style={{
                              display: "flex",
                              flexFlow: "column",
                              gap: "8px",
                              maxHeight: "400px",
                              minHeight: "30px",
                              paddingBottom: "16px",
                              overflowY: "scroll",
                              scrollbarWidth: "none",
                            }}
                          >
                            {
                              selectSubjectTeams.map((team) => {
                                const tmpTeam = teamList.find((v) => v.id === team.id)
                                if (!tmpTeam) return (<></>)
                                return (
                                  <div
                                    style={{
                                      position: "relative",
                                      border: openSubjectTeamIds.includes(tmpTeam.id) ? "solid 1px #CCCCCC" : "none",
                                      borderRadius: "4px",
                                      padding: openSubjectTeamIds.includes(tmpTeam.id) ? "20px 8px 8px" : "0",
                                      display: "flex",
                                      flexFlow: "column",
                                      gap: "8px",
                                      marginTop: "16px",
                                      backgroundColor: openSubjectTeamIds.includes(tmpTeam.id) ? "#FFFFFF" : "transparent",
                                    }}
                                    key={`target_team_id_${tmpTeam.id}`}
                                  >
                                    <button
                                      type="button"
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "4px",
                                        fontSize: "12px",
                                        transform: "translateY(-50%)",
                                        padding: "2px 8px",
                                        backgroundColor: "#FFFFFF",
                                        border: "solid 1px #CCCCCC",
                                        borderRadius: "16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                      onClick={() => toggleSubjectTeamId(tmpTeam.id)}
                                    >
                                      {`${tmpTeam.name}の${SCOPE_LABEL[team.scope]}${team.include_nested_teams ? " + 配下チーム" : ""}`}
                                      <FontAwesomeIcon
                                        icon={[
                                          'fas', openSubjectTeamIds.includes(tmpTeam.id) ? 'angle-up' : 'angle-down',
                                        ]}
                                      />
                                    </button>
                                    {
                                      openSubjectTeamIds.includes(tmpTeam.id) && ["both", "manager"].includes(team.scope) && (
                                        <div
                                          style={{
                                            position: "relative",
                                            border: "solid 1px #CCCCCC",
                                            borderRadius: "4px",
                                            backgroundColor: "#fbf4ff",
                                            padding: "12px 8px 8px",
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "4px",
                                            marginTop: "4px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "4px",
                                              fontSize: "10px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#FFFFFF",
                                              border: "solid 1px #CCCCCC",
                                              borderRadius: "14px",
                                            }}
                                          >
                                            マネージャー
                                          </div>
                                          <button
                                            type="button"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              right: "4px",
                                              fontSize: "8px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#ffeeee",
                                              border: "solid 1px #FF0000",
                                              color: "#FF0000",
                                              borderRadius: "16px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                            onClick={() => ejectSubjectTeamId(tmpTeam.id, "manager")}
                                          >
                                            削除する
                                          </button>
                                          {
                                            tmpTeam.managers.map((v) => buildMemberChip(v))
                                          }
                                          {
                                            !tmpTeam.managers.length && (
                                              <>
                                                このチームにマネージャーは設定されていません
                                              </>
                                            )
                                          }
                                        </div>
                                      )
                                    }
                                    {
                                      openSubjectTeamIds.includes(tmpTeam.id) && ["both", "member"].includes(team.scope) && !team.include_nested_teams && (
                                        <div
                                          style={{
                                            position: "relative",
                                            border: "solid 1px #CCCCCC",
                                            borderRadius: "4px",
                                            backgroundColor: "#f4fbff",
                                            padding: "12px 8px 8px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "4px",
                                            marginTop: "4px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "4px",
                                              fontSize: "10px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#FFFFFF",
                                              border: "solid 1px #CCCCCC",
                                              borderRadius: "14px",
                                            }}
                                          >
                                            このチームのメンバー
                                          </div>
                                          <button
                                            type="button"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              right: "4px",
                                              fontSize: "8px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#ffeeee",
                                              border: "solid 1px #FF0000",
                                              color: "#FF0000",
                                              borderRadius: "16px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                            onClick={() => ejectSubjectTeamId(tmpTeam.id, "member")}
                                          >
                                            削除する
                                          </button>
                                          {
                                            tmpTeam.members.map((v) => buildMemberChip(v))
                                          }
                                          {
                                            !tmpTeam.members.length && (
                                              <>
                                                このチームにメンバーは設定されていません
                                              </>
                                            )
                                          }
                                        </div>
                                      )
                                    }
                                    {
                                      openSubjectTeamIds.includes(tmpTeam.id) && ["both", "member"].includes(team.scope) && team.include_nested_teams && (
                                        <div
                                          style={{
                                            position: "relative",
                                            border: "solid 1px #CCCCCC",
                                            borderRadius: "4px",
                                            backgroundColor: "#f4fbff",
                                            padding: "12px 8px 8px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "4px",
                                            marginTop: "4px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "4px",
                                              fontSize: "10px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#FFFFFF",
                                              border: "solid 1px #CCCCCC",
                                              borderRadius: "14px",
                                            }}
                                          >
                                            このチームのメンバー + 配下チームに所属している全てのマネージャー・メンバー
                                          </div>
                                          <button
                                            type="button"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              right: "4px",
                                              fontSize: "8px",
                                              transform: "translateY(-50%)",
                                              padding: "2px 8px",
                                              backgroundColor: "#ffeeee",
                                              border: "solid 1px #FF0000",
                                              color: "#FF0000",
                                              borderRadius: "16px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                            onClick={() => ejectSubjectTeamId(tmpTeam.id, "member")}
                                          >
                                            削除する
                                          </button>
                                          {
                                            Array.from(new Map([
                                              ...getAllMemberList(team.id || null),
                                              ...tmpTeam.members,
                                            ].map((w) => [w.id, w])).values()).sort((a, b) => a.id - b.id).map((w) => (
                                              buildMemberChip(w)
                                            ))
                                          }
                                        </div>
                                      )
                                    }
                                  </div>
                                )
                              })
                            }
                          </div>
                        )
                      }
                      {
                        !isAlertTargetTeam && !!selectSubjectMemberIds.length && (
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {
                              memberList.filter((v) => selectSubjectMemberIds.includes(v.id)).map((v) => buildMemberChip(v, ejectSubjectMember))
                            }
                          </div>
                        )
                      }
                      {
                        isAlertTargetTeam ? (
                          <AddTeamAndMemberModule
                            selectMemberIdList={selectSubjectMemberIds}
                            selectTeamList={selectSubjectTeams}
                            callback={(result) => changeSubject(result)}
                            memberList={
                              memberList.map((v) => ({
                                id: v.id, name: v.name, kana: v.kana, profile_image: v.profile_image, active: true,
                              }))
                            }
                            teamList={teamList}
                            defaultSelectScope="member"
                            displayType={isAlertTargetTeam ? "team" : "member"}
                          />
                        ) : (
                          <AddMemberGroupingModule
                            memberIdList={selectSubjectMemberIds}
                            callbackMembers={(val) => changeSubject({ members: val, teams: [] })}
                            memberList={
                              memberList.map((v) => ({ id: v.id, name: v.name, profile_image: v.profile_image, active: v.active }))
                            }
                            teamList={teamList.map((v) => ({
                              ...v,
                              team_id: v.id,
                              count: 0,
                              created_at: "",
                              managers: v.managers.map((w) => ({ ...w, contract: "", place: "" })),
                              members: v.members.map((w) => ({ ...w, contract: "", place: "" })),
                            }))}
                          />
                        )
                      }
                    </div>
                  </div>
                </div>
                {
                  errors.subject && (
                    <div className="error">
                      {errors.subject}
                    </div>
                  )
                }
              </div>
              <div className="item">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    color: "#00954e",
                  }}
                >
                  <FontAwesomeIcon icon={['far', 'paper-plane']} fixedWidth />
                  アラート通知を受け取るユーザー
                  <div
                    style={{
                      color: "#4472BA",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "10px",
                      fontWeight: "normal",
                    }}
                    onClick={() => {
                      setIsDisplayRecipientMail(true)
                    }}
                    role="none"
                  >
                    通知サンプル画像
                  </div>
                </div>
                <div className="detail row_1">
                  <div
                    style={{
                      border: "solid 1px #CCCCCC",
                      borderRadius: "4px",
                      padding: "16px 8px 8px",
                      display: "flex",
                      flexFlow: "column",
                      gap: "4px",
                      flexWrap: "wrap",
                      backgroundColor: "#e6fff3",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                        padding: "8px",
                        display: "flex",
                        flexFlow: "column",
                        gap: "4px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "4px",
                          transform: "translateY(-50%)",
                          padding: "0 4px",
                          fontSize: "10px",
                          backgroundColor: "#e6fff3",
                        }}
                      >
                        アラート対象の全情報を受け取るユーザー
                      </div>
                      {
                        !!selectRecipientMemberIds.length && (
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {
                              memberList.filter((v) => selectRecipientMemberIds.includes(v.id)).map((v) => buildMemberChip(v, ejectRecipientMember))
                            }
                          </div>
                        )
                      }
                      <AddMemberGroupingModule
                        memberIdList={selectRecipientMemberIds}
                        callbackMembers={(val) => changeRecipient({ members: val, teams: [] })}
                        memberList={
                          memberList.map((v) => ({ id: v.id, name: v.name, profile_image: v.profile_image, active: v.active }))
                        }
                        teamList={teamList.map((v) => ({
                          ...v,
                          team_id: v.id,
                          count: 0,
                          created_at: "",
                          managers: v.managers.map((w) => ({ ...w, contract: "", place: "" })),
                          members: v.members.map((w) => ({ ...w, contract: "", place: "" })),
                        }))}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                        padding: "8px",
                        backgroundColor: "#FFFFFF",
                        fontSize: "10px",
                        cursor: "pointer",
                        color: isNotifySelf ? "#008800" : "#666666",
                        userSelect: "none",
                      }}
                      onClick={() => setIsNotifySelf((cur) => !cur)}
                      role="none"
                    >
                      <div>
                        <FontAwesomeIcon icon={['far', isNotifySelf ? 'check-square' : 'square']} />
                      </div>
                      <div>
                        条件に該当したら、本人にも通知する
                      </div>
                      <div
                        style={{
                          color: "#4472BA",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          setIsDisplaySubjectMail(true)
                          e.stopPropagation()
                        }}
                        role="none"
                      >
                        本人通知サンプル画像
                      </div>
                    </div>
                  </div>
                </div>
                {
                  errors.recipient && (
                    <div className="error">
                      {errors.recipient}
                    </div>
                  )
                }
              </div>
              {
                slackChannelList.length ? (
                  <div className="item">
                    <div
                      className="title"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        color: "#00954e",
                      }}
                    >
                      <FontAwesomeIcon icon={['far', 'paper-plane']} fixedWidth />
                      アラートのSlackチャンネル通知
                    </div>
                    <div className="detail row_1">
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column",
                          gap: "8px",
                          border: "solid 1px #CCCCCC",
                          borderRadius: "4px",
                          padding: "8px",
                          backgroundColor: "#e6fff3",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "10px",
                            cursor: "pointer",
                            color: isNotifySlack ? "#008800" : "#666666",
                            userSelect: "none",
                          }}
                          onClick={() => setIsNotifySlack((cur) => !cur)}
                          role="none"
                        >
                          <div>
                            <FontAwesomeIcon icon={['far', isNotifySlack ? 'check-square' : 'square']} />
                          </div>
                          <div>
                            Slackにアラート通知を送信する
                          </div>
                        </div>
                        {
                          isNotifySlack && (
                            <div>
                              <div className="slack_channel_item" style={{ backgroundColor: "#FFFFFF" }}>
                                <div className="selected_item">
                                  <div
                                    className="modal_trigger"
                                    role="none"
                                    onClick={openSlackChannelListSelectBox}
                                  />
                                  <p>
                                    {
                                      slackChannelList.find((value) => value.checked)?.id && slackChannelList.find((value) => value.checked)?.is_private && (
                                        <FontAwesomeIcon icon={['fas', 'lock']} className="pre_icon" />
                                      )
                                    }
                                    {
                                      slackChannelList.find((value) => value.checked)?.id && !slackChannelList.find((value) => value.checked)?.is_private && (
                                        <FontAwesomeIcon icon={['fas', 'hashtag']} className="pre_icon" />
                                      )
                                    }
                                    {
                                      slackChannelList.find((value) => value.checked)?.name || "-"
                                    }
                                  </p>
                                  <FontAwesomeIcon icon={['fas', 'caret-down']} className="icon" />
                                </div>
                                <div className={`select_box slack_channel_select ${isDisplaySlackChannelListSelectBox || "none"}`}>
                                  <div className="search_area">
                                    <FontAwesomeIcon
                                      icon={['fas', 'search']}
                                      className="icon"
                                    />
                                    <input
                                      type="text"
                                      placeholder="チャンネル名で検索"
                                      onChange={(event) => searchSlackChannelList(event.target.value)}
                                      value={searchSlackChannelListWord}
                                    />
                                    {
                                      searchSlackChannelListWord && (
                                        <button type="button" className="reset" onClick={resetSearchSlackChannelList}>
                                          <FontAwesomeIcon icon={['far', 'times-circle']} />
                                        </button>
                                      )
                                    }
                                  </div>
                                  <div className="select_list">
                                    {
                                      slackChannelList && slackChannelList.map((value: DisplaySlackChannelList) => (
                                        value.display && (
                                          <div
                                            key={value.id}
                                            className="select_row single"
                                            onClick={() => clickSlackChannelList(value.id)}
                                            role="none"
                                          >
                                            {
                                              value.id && value.is_private && (
                                                <FontAwesomeIcon icon={['fas', 'lock']} className="pre_icon" />
                                              )
                                            }
                                            {
                                              value.id && !value.is_private && (
                                                <FontAwesomeIcon icon={['fas', 'hashtag']} className="pre_icon" />
                                              )
                                            }
                                            {value.name}
                                          </div>
                                        )
                                      ))
                                    }
                                  </div>
                                </div>
                              </div>
                              {
                                errors.slack && (
                                  <div className="error">
                                    {errors.slack}
                                  </div>
                                )
                              }
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {
                      isNotifySlack && (
                        <div className="item">
                          <div
                            className="title"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#00954e",
                            }}
                          >
                            <FontAwesomeIcon icon={['far', 'paper-plane']} fixedWidth />
                            アラートのSlackチャンネル通知
                          </div>
                          <div className="detail row_1">
                            <Tips
                              description="Slack連携されていないため、変更できません"
                              className=""
                              icon={false}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexFlow: "column",
                                  gap: "8px",
                                  border: "solid 1px #CCCCCC",
                                  borderRadius: "4px",
                                  padding: "8px",
                                  backgroundColor: "#EEEEEE",
                                  cursor: "not-allowed",
                                  userSelect: "none",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    fontSize: "10px",
                                    cursor: "pointer",
                                    color: "#666666",
                                    userSelect: "none",
                                  }}
                                >
                                  <div>
                                    アラート通知するSlackチャンネル
                                  </div>
                                </div>
                                <div>
                                  <FontAwesomeIcon
                                    icon={['fas', customAlertModalState.customAlertDetail?.recipient.slack_channel?.is_private ? 'lock' : 'hashtag']}
                                    className="pre_icon"
                                  />
                                  {customAlertModalState.customAlertDetail?.recipient.slack_channel?.name}
                                </div>
                              </div>
                            </Tips>
                          </div>
                        </div>
                      )
                    }
                  </>
                )
              }
              <div className="item">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FontAwesomeIcon icon={['far', 'clock']} fixedWidth />
                  アラート通知を受け取るタイミング
                </div>
                <div
                  className="detail equal_space row_2"
                  style={{
                    gap: "4px",
                  }}
                >
                  {
                    isCustomTiming ? (
                      <>
                        <div
                          style={{
                            position: "relative",
                            width: "50%",
                          }}
                        >
                          <select
                            value={timing.type}
                            onChange={(event) => updateTimingType(event)}
                            style={{
                              width: "100%",
                            }}
                          >
                            {
                              TIMING_TYPE.map((v) => (
                                <option
                                  key={v.value}
                                  value={v.value}
                                  disabled={v.value === TIMING_VALUES.IMMEDIATE && !canUseImmediateTiming(conditions)}
                                >
                                  {v.label}
                                </option>
                              ))
                            }
                          </select>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "8px",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <FontAwesomeIcon icon={['fas', 'caret-down']} />
                          </div>
                        </div>
                        <div
                          style={{
                            position: "relative",
                            width: "50%",
                          }}
                        >
                          {(() => {
                            const isDisabled = timing.type === TIMING_VALUES.IMMEDIATE
                            const baseStyle = { width: "100%" }
                            const disabledStyle = {
                              ...baseStyle,
                              backgroundColor: "#F5F5F5",
                              borderColor: "#DDDDDD",
                              cursor: "not-allowed",
                              color: "#999999",
                            }
                            return (
                              <select
                                value={timing.time}
                                onChange={(event) => updateTimingTime(event)}
                                disabled={isDisabled}
                                style={isDisabled ? disabledStyle : baseStyle}
                              >
                                {
                                  timeForSelect.map((v) => (
                                    <option key={v.value} value={v.value}>{v.value}</option>
                                  ))
                                }
                              </select>
                            )
                          })()}
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "8px",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <FontAwesomeIcon icon={['fas', 'caret-down']} />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "16px",
                          }}
                        >
                          {TIMING_TYPE.find((v) => v.value === timing.type)?.label}
                          {timing.type === TIMING_VALUES.IMMEDIATE ? "" : timing.time}
                        </div>
                        <button
                          type="button"
                          onClick={() => setIsCustomTiming(true)}
                          style={{
                            border: "solid 1px #CCCCCC",
                            borderRadius: "4px",
                            fontSize: "10px",
                            padding: "4px 8px",
                          }}
                        >
                          送信タイミングを細かく設定する
                        </button>
                      </div>
                    )
                  }
                </div>
                {
                  errors.timing_type && (
                    <div className="error" style={{ whiteSpace: "pre-line" }}>
                      {errors.timing_type}
                    </div>
                  )
                }
              </div>
            </div>
            <div
              style={{
                width: `calc(100% - ${LEFT_AREA_WIDTH + 24}px)`,
              }}
            >
              <div className="item">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'list']} fixedWidth />
                  条件（複数選択可）
                </div>
                <div
                  style={{
                    border: "solid 1px #CCCCCC",
                    borderRadius: "4px",
                    padding: "8px",
                  }}
                >
                  {conditionHTML}
                </div>
                {
                  errors.condition && (
                    <div className="error">
                      {errors.condition}
                    </div>
                  )
                }
                {
                  conditions.length < 11 && (
                    <div className="add_conditions" role="presentation" onClick={addCondition}>
                      <FontAwesomeIcon icon={['fas', 'plus']} style={{ marginRight: '4px' }} fixedWidth />
                      条件を追加する
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          <div
            className={`
              close_screen
              ${
                (isDisplayApplicationTimeSelectBox
                  || isDisplayApplicationBizSelectBox
                  || isDisplaySlackChannelListSelectBox
                ) || 'none'}
            `}
            role="presentation"
            onClick={closeSelectBox}
          />
        </>
        <>
          <button type="button" className="button cancel" onClick={closeCallback}>
            キャンセル
          </button>
          <button
            type="button"
            className="button"
            onClick={saveCustomAlert}
          >
            アラートを編集する
          </button>
        </>
      </Modal>
      <Modal
        show={isDisplayRecipientMail}
        wrapperClass="mail_sample"
        closeCallback={() => setIsDisplayRecipientMail(false)}
        closeable
      >
        <>
          <img src="/static/images/custom_alert/manager_ja.png" alt="sample" />
        </>
      </Modal>
      <Modal
        show={isDisplaySubjectMail}
        wrapperClass="mail_sample"
        closeCallback={() => setIsDisplaySubjectMail(false)}
        closeable
      >
        <>
          <img src="/static/images/custom_alert/member_ja.png" alt="sample" />
        </>
      </Modal>
    </>
  )
}

export default CustomAlertModal
